import { Box, Button, Typography, useTheme } from '@mui/material'

import MicrophoneIcon from '../icons/MicrophoneIcon'
import { AudioRecord as AudioRecordProps } from '../interface'
import audioRecordStyles from '../styles'

type StartRecordBoxProps = Pick<AudioRecordProps, 'startText'> & {
  startRecording: () => Promise<void>
}

export default function StartRecordBox({
  startText,
  startRecording,
}: StartRecordBoxProps): JSX.Element {
  const { audioWrap, iconBox, innerText } = audioRecordStyles

  const theme = useTheme()
  const primaryColor = theme.palette.primary.main

  return (
    <Button
      onClick={() => {
        void startRecording()
      }}
      sx={audioWrap}
    >
      <Box sx={iconBox}>
        <MicrophoneIcon color={primaryColor} />
      </Box>
      <Typography sx={innerText}>{startText}</Typography>
    </Button>
  )
}
